/**
 * @generated SignedSource<<8be29620b3e318f5d920f04e419b81ab>>
 * @relayHash 9918fd7f4d3238b883a9bad359bb21b5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9918fd7f4d3238b883a9bad359bb21b5

import { ConcreteRequest, Query } from 'relay-runtime';
export type IssueCommentViewerGhostUserQuery$variables = {
  ghostLogin: string;
};
export type IssueCommentViewerGhostUserQuery$data = {
  readonly user: {
    readonly avatarUrl: string;
    readonly login: string;
  } | null;
};
export type IssueCommentViewerGhostUserQuery = {
  response: IssueCommentViewerGhostUserQuery$data;
  variables: IssueCommentViewerGhostUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ghostLogin"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "login",
    "variableName": "ghostLogin"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueCommentViewerGhostUserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueCommentViewerGhostUserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9918fd7f4d3238b883a9bad359bb21b5",
    "metadata": {},
    "name": "IssueCommentViewerGhostUserQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fda1a1c7f6b53d3281807f466eaa7691";

export default node;
